firebird.factory('videoKeyFrameService', [
    'logService',
    'socketService',
    'configService',
    'videoGlobalService',
    function (logService, socketService, configService, videoGlobalService) {
        var service = {
            initialize: initialize
        };

        var self, $scope;

        return service;

        function initialize(selfParam) {
            self = selfParam;
            $scope = videoGlobalService.data.$scope;

            self.initKeyFrame = initKeyFrame;

            self.requestKeyFrame = requestKeyFrame;
            self.onVFITriggered = onVFITriggered;
            self.useVFI = true;

            self.collateIntervalVFI = 2000; // multiple keyframe requests within 2s from viewers are ignored, only first is honored.

            self.requestKeyFrame = requestKeyFrame;
            self.onVFITriggered = onVFITriggered;
            self.useVFI = true;

            // when freeswitch indicates vfi for this member
            $scope.$on('vfi-triggered', onVFITriggered);
        }

        // update from config
        function initKeyFrame() {
            // useVFI - default true, can be turned on by url params
            self.useVFI = configService.getClientValue('useVFI') != 'false';
        }

        function onVFITriggered(e, data) {
            if (!self.useVFI) {
                logService.log('videoroomCtrl vfi-triggered ignored');
                return;
            }

            var is_screen = !!data.isScreenShare;

            var plugin = null;
            if (is_screen && self.screenshare) {
                plugin = self.screenshare;
            } else if (!is_screen && self.videoroom) {
                plugin = self.videoroom;
            }

            if (plugin) {
                if (data.collate) {
                    var now = new Date().getTime();
                    if (plugin.lastVFI && now - plugin.lastVFI <= self.collateIntervalVFI) {
                        logService.log('videoroomCtrl vfi-triggered ignored, collated');
                        return;
                    }
                    plugin.lastVFI = now;
                }

                logService.log('videoroomCtrl vfi-triggered ' + JSON.stringify(data));
                plugin.send({ message: { request: 'configure', keyframe: true } });
            }
        }

        // send a request-key-frame if remote publisher, or call onVFITriggered if local.
        // id is the attendee ID number of the remote publisher.
        // collate if true is sent in the message to remote publisher, so that it can ignore multiple
        // requests in short interval.
        function requestKeyFrame(id, collate) {
            logService.log('videoroomCtrl requestKeyFrame ' + id);
            if (id == self.attendantId) {
                self.onVFITriggered(null, {});
            } else {
                var is_screen = false;
                if (self.isScreenshareId(id)) {
                    is_screen = true;
                    id = self.getAttendantIdFromScreenshareId(id);
                }
                var data = { type: 'request-key-frame', screen: is_screen, to: parseInt(id) };
                if (collate) {
                    data.collate = collate;
                }
                socketService.send({
                    message: 'attendee-message',
                    data: data
                });
            }
        }
    }
]);
